module.exports = "/images/bg_everest55.jpg?68e9aa6938ba71dca2313e0f3834ce9f";